import createAxios from '@/app/core/AxiosCore';
import config from '@/app/config/app';

const axios = createAxios(config);

export default function createCrudApi(baseURL) {
  
  function listar(paginacao) {
    return axios.get(baseURL, { params: paginacao }).then((response) => response.data);
  }
  
  function filtrarLetra(letra) {
    return axios.get(baseURL, { params: { letra } }).then((response) => response.data);
  }
  
  function buscar(busca) {
    return axios.get(`${baseURL}/buscar?busca=${busca}`).then((response) => response.data);
  }
  
  function buscarCodigo(codigo) {
    return axios.get(`${baseURL}/buscarCodigo?codigo=${codigo}`).then((response) => response.data);
  }
  
  function abrir(id) {
    return axios.get(`${baseURL}/${id}`).then((response) => response.data);
  }
  
  function salvar(objeto) {
    return axios.post(baseURL, objeto).then((response) => response.data);
  }
  
  function atualizar(objeto) {
    return axios.put(`${baseURL}/${objeto.id}`, objeto).then((response) => response.data);
  }
  
  function excluir(id) {
    return axios.delete(`${baseURL}/${id}`).then((response) => response.data);
  }
  
  return {
    axios,
    listar,
    filtrarLetra,
    buscar,
    buscarCodigo,
    abrir,
    salvar,
    atualizar,
    excluir,
  };

}

